/**
 * @param self defines if the userId is the person requesting this URL
 */
export const getProfileRatingUrl = (userId: number, self?: boolean) =>
  self ? '/m-profile/reviews' : `/o-profile/${userId}/reviews`
